// extracted by mini-css-extract-plugin
export default {"container":"error-page-module__container___xHh8I"};